import { createSlice } from '@reduxjs/toolkit'
import {
  uploadFileAction
} from './common.action'

const initialState: Study.StudyState = {
  isLoading: false,
  error: null,
  studies: {
    limit: 0,
    page: 0,
    records: [],
    total: 0,
    totalPage: 0,
  },
}

const { actions, reducer } = createSlice({
  name: 'case_study_slice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadFileAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(uploadFileAction.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(uploadFileAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })
  },
})

export { reducer }
export default actions
